/** @jsx jsx */
import { jsx } from '@emotion/core';
import utils from '../../../utils';
import { SiteLink } from '../../../components';
import { tileStyle } from './productTileStyle';

export function ProductTile({ product }) {
  const s = tileStyle;
  const imageUrl = product.thumbnailUrl ? utils.site.resourcePath(product.thumbnailUrl) : '/assets/product-empty.png';
  //console.log("product : ", product)
  const productUrl = product.productUrl ? product.productUrl : `/product/${product.productSlug}`;
  return (
    <div css={[s.tile]}>
      <SiteLink css={s.tileLink} to={productUrl}>
        <div className="productTile__prdImage" css={s.prdImage}>
          <div className="productTile__bg" css={s.bg} style={{ backgroundImage: utils.css.bgUrlStyle(imageUrl) }}></div>
        </div>
        <div css={s.detailsContainer}>
          <div css={s.name}>
            {product.productName}
            {/* <div className="productTile__inlineRating">
            <div data-bv-show="inline_rating" data-bv-product-id={product.productCode}></div>
          </div> */}
          </div>
          <hr css={s.hr} />
          <div css={s.shortDes}>
            {product.shortDesc}
          </div>

          <div css={s.priceContainer}>
              <div css={s.price}>
                {
                  product.productStatus !== 0 ? product.productStatusText :
                    product.priceTextOveriding ? product.priceTextOveriding :
                      product.salePrice ? (
                        <span>
                          <span css={s.originalPrice}>{utils.money.formatMoney(product.priceIncTax)}</span>
                          {' '}
                          <span css={s.salePrice}>{utils.money.formatMoney(product.salePrice)}</span>
                        </span>
                      ) : utils.money.formatMoney(product.priceIncTax)
                }
              </div>
              {product.productStatus === 0 && (
                <SiteLink to={productUrl} css={s.viewProduct}>
                  Buy Now
                </SiteLink>
              )}
              {/* {product.productStatus === 100 && (
                <SiteLink to={productUrl} css={s.viewProduct}>
                  Enquire Now
                </SiteLink>
              )} */}
          </div>

        </div>


      </SiteLink>
    </div>
  )
}